import './App.css';
import React,{useEffect} from 'react';
import Navbar from './Components/Navbar/Navbar';
import leaveOne from './images/fone.png';
import leaveTwo from './images/sone.png';
import leaveThree from './images/tone.png';
import rleaveOne from './images/rfone.png';
import rleaveTwo from './images/rsone.png';
import rleaveThree from './images/rtone.png';
import rleaveFourth from './images/rtone.png';
import Logo from './images/Final Logo.png';
import { FaInstagram } from 'react-icons/fa';
import { AiFillFacebook } from 'react-icons/ai';
import { FaTiktok } from 'react-icons/fa';
import {BsMessenger} from 'react-icons/bs';
import {AiFillShopping} from 'react-icons/ai'
import ReactGa from 'react-ga'


function App() {

  useEffect(() =>{
    ReactGa.initialize('UA-219883764-1')
    ReactGa.pageview('/')
},[])           
          
  return (
    <section className="App">    
     <img src = {Logo} className= 'logo'/> 
     <div className='Links_box'>
       <a href='https://instagram.com/aesthetic_king_apparel?utm_medium=copy_link'>
        <div className='Link_box'>
            <FaInstagram className='icon ig'/>
            <span className='text'>Follow Us On Instagram</span>
        </div> 
       </a>
       <a href='https://www.facebook.com/Aesthetic-King-104658482133623'>
        <div className='Link_box'>
            <AiFillFacebook className='icon fb'/>
            <span className='text'>Follow Us On Facebook</span>
        </div> 
       </a>
       <a href='https://vm.tiktok.com/ZSetyJ3kP/'>
        <div className='Link_box'>
            <FaTiktok className='icon tt'/>
            <span className='text'>Follow Us On Tiktok</span>
        </div> 
       </a>
     </div>   

      <a href ='https://www.shop.com.mm/shop/aesthetic-king?liteShop=true&spm=a2a0e.store_product.top.share&dsource=share&laz_share_info=479065_100_200_800503494315_447387_null&laz_token=8480901380a3850348ab0bf5c611d68e'>
       <button className='order_btn'>
         <span>Shop Here</span>
         <AiFillShopping className='messenger'/>
      </button>
     </a>

     <img src = {leaveOne} className ="leave leaveOne"/>
     <img src = {leaveTwo} className ="leave leaveTwo"/>
     <img src = {leaveThree} className ="leave leaveThree"/>
     <img src = {rleaveOne} className ="leave rleaveOne"/>
     <img src = {rleaveTwo} className ="leave rleaveTwo"/>
     <img src = {rleaveThree} className ="leave rleaveThree"/>
     <img src = {leaveOne} className ="leave mleave"/>

    </section>
  );
}

export default App;
